import { render, staticRenderFns } from "./CustomObject.vue?vue&type=template&id=249bc84c"
import script from "./CustomObject.vue?vue&type=script&lang=js"
export * from "./CustomObject.vue?vue&type=script&lang=js"
import style0 from "./CustomObject.vue?vue&type=style&index=0&id=249bc84c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports